<div class="slideout-content">
    <!-- Modal to add new user starts-->
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0" [formGroup]="expenseForm">
                <button type="reset" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="toggleSidebar('create-expense')">
                    ×
                </button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title" id="exampleModalLabel">Masraf</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <div class="form-group">
                                <label for="kindName">Masraf Adı</label>
                                <input type="text" formControlName="name" class="form-control"
                                    placeholder="Masraf Adı Giriniz." />
                                <div *ngIf="expenseForm.get('name').invalid">
                                    <small class="text-danger" *ngIf="expenseForm.get('name').errors.required">Masraf
                                        adı
                                        zorunludur.</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-1">
                            <div class="form-group">
                                <label for="kindName">Masraf Türü</label>
                                <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" [clearable]="true"
                                    formControlName="kindId">
                                </ng-select>
                                <div *ngIf="expenseForm.get('name').invalid">
                                    <small class="text-danger" *ngIf="expenseForm.get('name').errors.required">Masraf
                                        Türü
                                        zorunludur.
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-1">
                            <div class="form-group">
                                <label for="kindName">Ana Masraf Seç</label>
                                <ng-select [items]="mainExpenses" bindLabel="name" bindValue="id" [clearable]="true"
                                    formControlName="mainExpenseId">
                                </ng-select>
                                <div *ngIf="expenseForm.get('mainExpenseId').invalid">
                                    <small class="text-danger"
                                        *ngIf="expenseForm.get('mainExpenseId').errors.required">Ana Masraf
                                        zorunludur.</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <button type="submit" [disabled]="expenseForm.invalid" class="btn btn-primary col-12 mb-1"
                                (click)="onSubmit()" rippleEffect>
                                {{ expense ? 'Güncelle' : 'Ekle' }}
                            </button>
                            <button type="reset" class="btn btn-outline-secondary col-12 mb-1"
                                (click)="toggleSidebar('create-expense')" rippleEffect>
                                İptal
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new user Ends-->
</div>